import { LoaderFileKeys } from "../../constant/AppConstants";
import { AppLocalization } from "../../localization/AppLocalization";
import { LayoutDataManager } from "../../managers/LayoutDataManager";
import { AppSettings } from "../../managers/AppSettings";
import { TrumpSuit } from "../../state/TableStateMachine";
import { TrumpSuitToCardSuit } from "../../utils/TrumpsSuitToCardSuit";
import { GetCardSuitIconTextureStatesData, TrumpIconType } from "../../utils/GetCardSuitIconTextureData";

/**
 * Used specifically in Coinche / Deal Complete / Deals / DealListItem to display contract. Structure:
 * [label1][icon][label2]
 */
export class DealListItemContractItem 
    extends Phaser.GameObjects.Container
{
    public label1: Phaser.GameObjects.Text;
    public icon: Phaser.GameObjects.Image;
    public label2: Phaser.GameObjects.Text;

    protected labelStyle: Phaser.Types.GameObjects.Text.TextStyle;
    protected itemSpacing: number = 10;
    

    public Init(labelStyle: Phaser.Types.GameObjects.Text.TextStyle): void
    {
        this.labelStyle = labelStyle;
    }
    
    public Build(): void
    {
        this.label1 = this.scene.make.text({style: this.labelStyle});
        this.label1.setOrigin(1, 0.5);
        this.add(this.label1);

        this.icon = this.scene.make.image({});
        // this.icon.setOrigin(0.5); // custom origin via TP
        this.add(this.icon);

        this.label2 = this.scene.make.text({style: this.labelStyle});
        this.label2.setOrigin(0, 0.5);
        this.add(this.label2);
    }
    
    public SetData(inputData: any): void
    {

        let totalWidth: number = 0;

        const trumpSuit: TrumpSuit = inputData.trumpSuit;
        const label1: string = inputData.label1;
        const label2: string = inputData.label2;
        
        // label1
        if (label1 != undefined) {
            this.label1.text = label1;
            this.label1.visible = true;
            totalWidth += (this.label1.displayWidth + this.itemSpacing);
        }
        else {
            this.label1.visible = false;
        }

        // label2
        // use label2 also in specific case of label2 being undefined, but trumpSuit=AT|NT
        let useLabel2: boolean = false;
        if (label2 != undefined) {
            useLabel2 = true;
            this.label2.text = label2;
            this.label2.visible = true;
            totalWidth += (this.label2.displayWidth + this.itemSpacing);
        }
        // label2 is undefined
        else {
            // special case: AT|NT
            // EDIT: We could use label2 for "AT" / "NT" text, but only if label2 is undefined, because if NT|AT is Bid with Surcoinche, we can't use label2 for that.. we could also only use label2 in case Surcoinche wasnt called.. (maybe best >> YES THIS.)
            if (trumpSuit == TrumpSuit.ALLTRUMPS) {
                useLabel2 = true;
                this.label2.text = AppLocalization.GetSharedData().general.allTrumpsShortText;
                this.label2.visible = true;
                totalWidth += (this.label2.displayWidth + this.itemSpacing);
            }
            else
            if (trumpSuit == TrumpSuit.NOTRUMPS) {
                useLabel2 = true;
                this.label2.text = AppLocalization.GetSharedData().general.noTrumpsShortText;
                this.label2.visible = true;
                totalWidth += (this.label2.displayWidth + this.itemSpacing);
            }
            else {
                this.label2.visible = false;
            }
        }

        // set icon based on trumpSuit
        switch(trumpSuit) {
            case TrumpSuit.ALLTRUMPS:
                this.icon.setTexture(LoaderFileKeys.cardsDeck, LayoutDataManager.GetSharedData().general.allTrumpsIconFrame.out);
                break;
            case TrumpSuit.NOTRUMPS:
                this.icon.setTexture(LoaderFileKeys.cardsDeck, LayoutDataManager.GetSharedData().general.noTrumpsIconFrame.out);
                break;
            case TrumpSuit.SPADES:
            case TrumpSuit.CLUBS:
            case TrumpSuit.DIAMONDS:
            case TrumpSuit.HEARTS:
                const cardSuit = TrumpSuitToCardSuit(trumpSuit);
                const iconTextureStatesData = GetCardSuitIconTextureStatesData(cardSuit, TrumpIconType.RESULTS_SCREEN);
                this.icon.setTexture(iconTextureStatesData.out.texture, iconTextureStatesData.out.frame);
                break;
        }
        totalWidth += this.icon.displayWidth;

        // reposition children
        let curPosX = -totalWidth * 0.5;
        if (label1 != undefined) {
            curPosX += this.label1.displayWidth;
            this.label1.x = curPosX;
            curPosX += this.itemSpacing;
        }
        this.icon.x = curPosX + this.icon.displayWidth * 0.5;
        curPosX += this.icon.displayWidth;
        if (useLabel2) {
            curPosX += this.itemSpacing;
            this.label2.x = curPosX;
        }
    }
}